import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ALL_TRIGGER_TYPES, Trigger } from 'dashboard/models/trigger';
import { Workflow, WorkflowStatus } from 'dashboard/models/workflow';
import { WorkflowDeployment } from 'dashboard/models/workflow-deployment';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import {
  setPaginationParams,
  setTriggers,
  setWorkflowDeployments,
  setWorkflows,
  setWorkflowVersions,
  WorkflowsFilterParams,
} from 'dashboard/redux/actions/workflows';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export const loadWorkflowsPaginated =
  (
    filters: WorkflowsFilterParams,
    currentPage: number,
    pageSize: number,
    sortings?: SortParams,
    environmentId?: string,
    abortSignal?: AbortSignal,
  ): DashboardThunkAction<
    Promise<{
      workflows: Workflow[];
      workflowVersions: WorkflowVersion[];
      workflowDeployments: WorkflowDeployment[];
      triggers: Trigger[];
    }>
  > =>
  async (dispatch) => {
    const {
      triggerTypes,
      omni,
      status = [WorkflowStatus.Running, WorkflowStatus.Paused],
      workflowIds,
      eventNames,
    } = filters;

    const params = {
      filter: {
        status,
        'trigger-type': triggerTypes,
        omni,
        'workflow-ids': workflowIds,
        'environment-id': environmentId,
        'event-names': eventNames,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
      ...(sortings
        ? {
            sort: `${sortings.shouldSortDescending ? '-' : ''}${sortings.sort}`,
          }
        : {}),
    };

    const {
      data: workflows,
      included,
      meta: paginationParams,
    } = await SessionClientDashboard.listResource<Workflow, PaginationParams>(
      ApiEndpoint.Workflow,
      params,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const workflowVersions = included.filter(
      (include): include is WorkflowVersion => include.type === ApiModel.WorkflowVersion,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const workflowDeployments = included.filter(
      (include): include is WorkflowDeployment => include.type === ApiModel.WorkflowDeployment,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const triggers = included.filter((include): include is Trigger =>
      ALL_TRIGGER_TYPES.some((triggerType) => triggerType === include.type),
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setPaginationParams(paginationParams));
    dispatch(setWorkflowVersions(workflowVersions));
    dispatch(setWorkflowDeployments(workflowDeployments));
    dispatch(setWorkflows(workflows));
    dispatch(setTriggers(triggers));

    return {
      workflows,
      workflowVersions,
      workflowDeployments,
      triggers,
    };
  };

export const loadWorkflows =
  (
    filters: WorkflowsFilterParams,
    sortings?: SortParams,
    environmentId?: string,
  ): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const {
      triggerTypes,
      omni,
      status = [WorkflowStatus.Running, WorkflowStatus.Paused],
      workflowIds,
      eventNames,
    } = filters;

    const params = {
      filter: {
        status,
        'trigger-type': triggerTypes,
        omni,
        'workflow-ids': workflowIds,
        'environment-id': environmentId,
        'event-names': eventNames,
      },
      ...(sortings
        ? {
            sort: `${sortings.shouldSortDescending ? '-' : ''}${sortings.sort}`,
          }
        : {}),
    };

    const { data: workflows, included } = await SessionClientDashboard.listResource<Workflow>(
      ApiEndpoint.Workflow,
      params,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const workflowVersions = included.filter(
      (include): include is WorkflowVersion => include.type === ApiModel.WorkflowVersion,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const workflowDeployments = included.filter(
      (include): include is WorkflowDeployment => include.type === ApiModel.WorkflowDeployment,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const triggers = included.filter((include): include is Trigger =>
      ALL_TRIGGER_TYPES.some((triggerType) => triggerType === include.type),
    );

    dispatch(setWorkflowVersions(workflowVersions));
    dispatch(setWorkflowDeployments(workflowDeployments));
    dispatch(setWorkflows(workflows));
    dispatch(setTriggers(triggers));
  };
